import React from "react";
import { favoriteSliceAction } from "../redux/favorite/slice";
import { useDispatch } from "react-redux";


const FavoriteItem = (props) => {
const {id} = props;

  const dispatch = useDispatch();
  const rmvitem = (e) => {
    e.preventDefault();
    dispatch(favoriteSliceAction.rmvfavorite(id))
  }


  return (
    <div className="flex items-center border p-4 rounded-lg mb-4 lg:flex-nowrap flex-wrap">
      <button onClick={rmvitem} className="text-red-600 font-semibold lg:w-auto w-full">Remove</button>
      <div className="overflow-hidden flex w-40 h-36">
        <img
          className="w-auto m-auto h-auto px-4 max-h-full max-w-full"
          src={props.image}
          alt=""
        />
      </div>
      <p className="lg:text-xl text-md flex-1 px-4 font-semibold">{props.title}</p>
      <h3 className="lg:w-32 w-[50%] font-semibold lg:text-left text-center ">Price ${props.price}</h3>
      <div className="flex w-[160px] flex-col">
        <button className="bg-gray-500 py-2 rounded-md focus:outline-none text-white mb-2">
          Add To Cart
        </button>
      </div>
    </div>
  );
};

export default FavoriteItem;
